<template>
  <div id="home">
    <div class="banner">
      <!-- 导航 -->
      <NavCustom></NavCustom>
      <div class="banner-slogan">
        <img src="../assets/images/slogan.png" alt="" />
      </div>
      <!-- 服务 -->
      <Service />
    </div>
    <div class="info">
      <div class="info-title"><span>服务范围</span></div>
      <div class="video-box">
        <video
          id="my-video"
          class="video-js"
          controls
          preload="auto"
          playsinline
          webkit-playsinline
          poster="../assets/images/video_poster.png"
          data-setup="{}"
        >
          <source :src="videoUrl" type="video/mp4" />
          <p class="vjs-no-js">
            若要查看此视频，请启用JavaScript，并考虑升级到Web浏览器
          </p>
        </video>
        <img
          v-show="!isPaly"
          class="play"
          src="../assets/images/play-circle.png"
        />
      </div>
      <ul class="info-list">
        <li>
          <img src="../assets/images/icon_1.png" />
          <p>会展组织</p>
        </li>
        <li>
          <img src="../assets/images/icon_2.png" />
          <p>会展服务</p>
        </li>
        <li>
          <img src="../assets/images/icon_3.png" />
          <p>展陈服务</p>
        </li>
        <li>
          <img src="../assets/images/icon_4.png" />
          <p>数字会展</p>
        </li>
      </ul>
    </div>
    <!-- 展会项目 -->
    <ExhibitionProject />
    <!-- 会展服务 -->
    <ExhibitionService />
    <!-- 展陈业务 -->
    <ExhibitionItem />
    <!-- 行业布局 -->
    <!-- <IndustryLayout /> -->
    <!-- 年度展会 -->
    <!-- <AnnualExhibition /> -->
    <CompanyMore />
    <!-- 联系我们 -->
    <FooterCustom></FooterCustom>
  </div>
</template>

<script>
import NavCustom from "@/components/nav-custom.vue";
import ExhibitionProject from "@/components/home/exhibition-project.vue";
import ExhibitionItem from "@/components/home/exhibition-item.vue";
// import IndustryLayout from "@/components/home/industry-layout.vue";
// import AnnualExhibition from "@/components/home/annual-exhibition.vue";
import Service from "@/components/home/service.vue";
import ExhibitionService from "@/components/home/exhibition-service.vue";
import CompanyMore from "@/components/home/company-more.vue";
import FooterCustom from "@/components/footer-custom.vue";
import videoJS from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "home-page",
  components: {
    NavCustom,
    ExhibitionProject,
    ExhibitionItem,
    // IndustryLayout,
    // AnnualExhibition,
    Service,
    ExhibitionService,
    CompanyMore,
    FooterCustom,
  },
  data() {
    return {
      videoUrl:
        "https://miniapp.static.zhongsheyun.com/中设集团官网/中设会展宣传片2021版.mp4",
      isPaly: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.loadVideo();
    });
  },
  methods: {
    // 调用
    loadVideo() {
      let _this = this;
      let options = {};
      // 监听 点击播放按钮
      videoJS("my-video", options, function onReady() {
        // 监听 点击播放按钮
        this.on("play", function () {
          _this.isPaly = true;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#home {
  background: #f6f9ff;
  .banner {
    width: 100%;
    height: 545px;
    background: #fff url("../assets/images/bg.png") no-repeat;
    background-size: cover;
    .banner-slogan {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: calc(100% - 143px);
      justify-content: center;
      font-size: 24px;
      color: #fff;
      img {
        width: 243px;
      }
    }
  }
  .video-box {
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    .play {
      position: absolute;
      width: 36px;
      height: 36px;
      pointer-events: none;
    }
  }
  /deep/.video-js {
    width: calc(100vw - 32px);
    max-height: 194px;
    object-fit: fill;
    .vjs-big-play-button {
      display: none;
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    background: #fff url("../assets/images/bg_1.png") no-repeat;
    background-size: cover;
    color: #666666;
    font-size: 20px;
    padding: 30px 16px 40px 16px;
    .info-title {
      display: flex;
      align-items: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      color: #0068b7;
      position: relative;
      margin-bottom: 50px;
      span {
        position: absolute;
        z-index: 2;
      }
    }
    .info-title::after {
      content: "SERVICES";
      position: absolute;
      font-weight: bold;
      font-size: 18px;
      color: #efefef;
      top: 1px;
      z-index: 1;
    }
    .info-title::before {
      content: "";
      width: 86px;
      height: 3px;
      background: #0068b7;
      position: absolute;
      top: 24px;
    }

    .info-list {
      display: flex;
      justify-content: space-between;
      padding-top: 16px;
      li {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          margin-bottom: 12px;
        }
      }
    }
  }
}
</style>